import { isMixpanelReady, waitForMixpanelReady } from "common/utils/mixpanel/wait-for-mixpanel";

const buildCampaignEnrichment = () => {
  if (!window.analyticsUtils || typeof window.analyticsUtils.getCampaignParams !== "function") {
    return { campaignProps: null, identify: null };
  }

  const { params, first_params: firstParams } = window.analyticsUtils.getCampaignParams();
  const hasCampaign = Object.keys(params).length > 0 || Object.keys(firstParams).length > 0;
  if (!hasCampaign) {
    return { campaignProps: null, identify: null };
  }

  let identify = null;
  const { getUserId, getUserTraits } = window.rudderanalytics;
  if (typeof getUserId === "function") {
    const userId = getUserId();
    if (userId) {
      const existingTraits = typeof getUserTraits === "function" ? getUserTraits() : {};
      const traitsToSet = { ...params };

      Object.keys(firstParams).forEach(key => {
        if (!existingTraits[key]) {
          traitsToSet[key] = firstParams[key];
        }
      });

      if (Object.keys(traitsToSet).length > 0) {
        identify = { userId, traits: traitsToSet };
      }
    }
  }

  return { campaignProps: params, identify };
};

const enrichForMixpanel = properties => {
  const windowProps = window.MIXPANEL_SUPER_PROPS || {};

  const options = { integrations: { Mixpanel: true } };
  let enrichedProps = { ...windowProps, ...properties };

  if (isMixpanelReady()) {
    options.context = options.context || {};
    options.context.mixpanel_distinct_id = window.mixpanel.get_distinct_id();
    options.context.mixpanel_session_id = window.mixpanel.get_property("session ID");

    if (typeof window.mixpanel.get_session_recording_properties === "function") {
      enrichedProps = {
        ...enrichedProps,
        ...window.mixpanel.get_session_recording_properties()
      };
    }
  }

  const campaignEnrichment = buildCampaignEnrichment();
  const finalProps = { ...enrichedProps, ...(campaignEnrichment.campaignProps || {}) };

  return {
    properties: finalProps,
    options,
    identify: campaignEnrichment.identify
  };
};

// Queue to guarantee enrichment for sendToMixpanel=true when Mixpanel isn't ready yet
const mpEventQueue = [];
let mpWaiterStarted = false;

const flushQueuedRudderEventsWithMixpanel = () => {
  while (mpEventQueue.length > 0) {
    const { eventType, properties } = mpEventQueue.shift();
    const { properties: finalProps, options, identify } = enrichForMixpanel(properties);
    if (identify) {
      window.rudderanalytics.identify(identify.userId, identify.traits);
    }
    window.rudderanalytics.track(eventType, finalProps, options);
  }
};

const trackRudderstackEvent = (eventType, properties = {}, sendToMixpanel = false) => {
  if (!sendToMixpanel) {
    window.rudderanalytics.track(eventType, properties);
    return;
  }

  if (isMixpanelReady()) {
    const { properties: finalProps, options, identify } = enrichForMixpanel(properties);
    if (identify) {
      window.rudderanalytics.identify(identify.userId, identify.traits);
    }
    window.rudderanalytics.track(eventType, finalProps, options);
    return;
  }

  // Mixpanel not ready → queue and start an indefinite waiter to ensure enrichment
  mpEventQueue.push({ eventType, properties });
  if (!mpWaiterStarted) {
    mpWaiterStarted = true;
    waitForMixpanelReady(flushQueuedRudderEventsWithMixpanel, { timeoutMs: 0 });
  }
};

export default trackRudderstackEvent;
